import MenuSection from "../MenuSection.js";
import React from "react";
import RegisterOrDepositMenuItem from "./RegisterOrDepositMenuItem.js";

const TopMenuSection = () => (
  <MenuSection>
    <RegisterOrDepositMenuItem />
  </MenuSection>
);

export default React.memo(TopMenuSection);
